import { useQuery } from '@tanstack/react-query';
import api from '../../services/api';
import { Meta } from '../Announcement/types';
import { queryKeys } from '../queryClient';
import { FiltersInvoice, ShopmanagerInvoice } from './useGetInvoice';

export type InvoiceStatusV2 =
    | 'AVENCER'
    | 'VENCEHOJE'
    | 'ATRASADO'
    | 'PAGTO_PARCIAL'
    | 'PAGO';

export interface InvoiceV2 {
    barcode: string | null;
    issuedAt: string;
    dueDate: string;
    status: InvoiceStatusV2;
    value: number;
    pendingAmount?: number;
    code: number;
    doc: string;
    shopmanager: ShopmanagerInvoice;
}

export interface InvoiceResponseV2 {
    meta: Meta;
    data: Array<InvoiceV2>;
}

export async function fetchInvoicesV2(filters: Partial<FiltersInvoice>) {
    const response = await api.get<InvoiceResponseV2>(`erp/v2/invoices`, {
        params: {
            ...filters,
        },
    });
    return response.data;
}

export function useGetInvoicesV2(
    filters: Partial<FiltersInvoice>,
    enableRequest: boolean,
) {
    return useQuery({
        queryKey: [...queryKeys.INVOICES_V2_ROOT, filters],
        queryFn: () => fetchInvoicesV2(filters),
        retry: false,
        refetchOnWindowFocus: false,
        enabled: enableRequest,
        keepPreviousData: enableRequest,
        staleTime: 30_000,
    });
}
